/**
 *
 * * * How to use AvatarViewController * * * * * * * * * * * * * * * * * *
 *
 * 1. Instantiate the ViewController
 *    var AvatarViewController = window.AvatarViewController || {};
 * 2. In "initialize" create a new avatar object. Give that object it's TEMPLATE name, CONSUMER_ID and a boolean stating
 *    if it's a singleton or not.
 *    this.avatar = new AvatarViewController({
 *             templateFile: TEMPLATE,
 *             context: this,
 *             modelController: this.modelController,
 *             wrapWithDiv: false,
 *             consumerId: CONSUMER_ID,
 *             isSingleton: this.singleton
 *          });
 * 3. Add the new avatar variable (from type AvatarViewController). Give it the CONTAINER in which to be rendered
 *    (if it's a class or ID don't forget to add "." or "#" before)
 *    this.addViewController({viewController:this.avatar, target: CONTAINER});
 * 4. Show the avatar! Call showAvatar() with the consumerId.
 *    this.avatar.showAvatar(consumerId);
 *
 *
 * * * Color Scheme * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *
 * The avatar will render a colored border based on an ancestor's classname. i.e. if an ancestor of the avatar
 * container has a classname matching a known color, it will be used to color the avatar border.
 * The color scheme list can be found at logicController.colorsScheme.
 *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *
 * Functions
 *
 * - showAvatar
 * - setImage
 * - initializeView
 */
define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var webAgentUtils = require('web-agent-utils/WebAgentUtils');

    var AvatarViewController = ViewController.extend({
        ControllerName: "AvatarViewController",

        LPViewMap: {
            avatar : "lp_view_avatar"
        },

        modelLocations: {
            image: "participantInfo.imageUrl",
            participantPath: "participants.myEngagements"
        },

        LPClassesMap: {
            showCustomImage: "showCustomImage",
            showDefaultImage: "showDefaultImage"
        },

        initialize : function (constructorData) {
            this.isSingleton = constructorData.isSingleton;
            this.consumerId = constructorData.consumerId;
            this.avatarView = this.getFirstElement('.' + this.LPViewMap.avatar);
        },

        events : function () {
            /*if (this.consumerId) {
             var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.consumerId);
             this.bindModel({modelPath: participantPath + '.' + this.modelLocations.image, callback: this.setImage});
             }*/
        },

        render : function () {
        }
    });

    AvatarViewController.prototype.getConfiguration = function () {
        return {
            customTemplate : "LP_avatar_custom.html",
            defaultTemplate : "LP_avatar_default.html"
        };
    };

    /**
     * The main function that is called when implementing "avatar" in a new component.
     *
     * @param consumerId
     **/
    AvatarViewController.prototype.showAvatar = function (consumerId, imageUrl) {
        this.consumerId = (this.isSingleton && consumerId) ? consumerId : this.consumerId;
        var isChanged = this.imageUrl !== imageUrl;
        this.imageUrl = imageUrl;
        this.setImage(isChanged);
    };

    /**
     * Sets the correct image class to the avatar div (showDefaultImage or showCustomImage).
     * Renders the new view, with the correct template and configuration.
     *
     **/
    AvatarViewController.prototype.setImage = function (shouldUpdate) {
        if (this.imageUrl === undefined || this.isSingleton || shouldUpdate){
            if (this.isSingleton || shouldUpdate) {
                this.removeView(this.viewOptions);
            }

            this.viewOptions = {
                target: this.avatarView,
                wrapWithDiv: false
            };
            if (this.imageUrl && webAgentUtils.isSecureUrl(this.imageUrl)) {
                this.addClass(this.avatarView, this.LPClassesMap.showCustomImage);
                this.removeClass(this.avatarView, this.LPClassesMap.showDefaultImage);
                this.viewOptions.templateFile = this.getConfiguration().customTemplate;
                this.viewOptions.textInjection = {imageUrl: this.imageUrl};
            } else {
                this.addClass(this.avatarView, this.LPClassesMap.showDefaultImage);
                this.removeClass(this.avatarView, this.LPClassesMap.showCustomImage);
                this.viewOptions.templateFile = this.getConfiguration().defaultTemplate;
                this.imageUrl = "";
            }

            this.createView(this.viewOptions);
        }
    };

    Object.defineProperty(AvatarViewController.prototype, 'imageUrl', {
        get: function () {
            return this._imageUrl || this.getModelParam("userProfiles." + this.consumerId + ".imgUrl");
        },
        set: function (value) {
            this._imageUrl = value || this.getModelParam("userProfiles." + this.consumerId + ".imgUrl");
        }
    });

    return AvatarViewController;

});
